import { FlyoutMenu } from './flyout-menu';

export var navigation = function () {
    //Setup Menu Listeners 
    FlyoutMenu.bindListeners();

    // Desktop search opening
    $('#searchFormButton').on('click', function(event) {
        event.stopPropagation(); // Prevent the click event from propagating to the document
        $('.search-wrapper-desktop--form').toggleClass('active-search');
        $('.menu-container').toggleClass('active-search');

        const element = document.getElementById('s');
        element.focus({
            preventScroll: true
        });
    });


    // // On click of menu button
    $(".menu-button").on("click", function () {
        $(this).toggleClass("open");
        $("body").toggleClass("fixed");
        const body = document.querySelector('body');

        var menuObject = $(".secondary-menu-container-wrapper");
        var menuObjectWidth = menuObject.width() + 100;

        if(body.classList.contains('fixed') == true){
            $(".secondary-nav__wrapper").css('display', 'block');
            $(".secondary-menu-container-wrapper").stop().animate({ right: 0 }, 500);
            
            setTimeout(function () {
                $(".secondary-menu-bg-overlay").stop().animate({ opacity: 1 }, 500);
            }, 300);
            
        } else {
            setTimeout(function(){$(".secondary-nav__wrapper").css('display', 'none');}, 500);
            $(".secondary-menu-container-wrapper").stop().animate({ right: -menuObjectWidth }, 500);
            $(".secondary-menu-bg-overlay").stop().animate({ opacity: 0 }, 300);            
        }
    });

    // On escape close menu
    $(document).keyup(function (e) {
        if (e.keyCode == 27) {
            $('.menu-button').removeClass('open');
            $('ul.sub-menu').removeClass('active');
            $('body').removeClass('fixed');
            $(".secondary-nav__wrapper").css('display', 'none');
            $('.menu-container').removeClass('active-search');
            $('.search-wrapper-desktop--form').removeClass('active-search');
        }
    });

    $(window).on('resize', function () {
        var win = $(this); //this = window
        if (win.width() < 980) {
            if ($('.menu-button').hasClass('open')) {
                //do nothing
            } else {
                $(".main-nav .menu-container").css('display', 'none');
            }
        }
    });
 
    $(document).on('click', function(event) {
        const searchButton = $('#searchFormButton');
        const searchForm = $('#searchFormContainer');;
        if (searchForm.hasClass('active-search') && !searchForm.is(event.target) && !searchButton.is(event.target) && searchForm.has(event.target).length === 0) {
            console.log("Document close search listener");
            $('.menu-container').removeClass('active-search');
            $('.search-wrapper-desktop--form').removeClass('active-search');
        }
    });
}